module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Employee-Separation/emp-sep-authorization/emp-sep-auth/emp-sep-auth.component.css
// module id = ./src/app/hrms/Employee-Separation/emp-sep-authorization/emp-sep-auth/emp-sep-auth.component.css
// module chunks = main